<template>
  <CModal
    :closeOnBackdrop="false"
    :show.sync="modal"
    :no-close-on-backdrop="false"
    :centered="true"
    title=""
    size="lg"
    color="dark"
  >
    <CRow>
      <CCol>
        <CCard>
          <CCardBody>
            <span class="labelsFont">{{ message }}</span>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <template #header>
      <CButtonClose @click="closeModal" class="text-white" />
    </template>
    <template #footer>
      <CButton @click="closeModal" color="info">閉じる</CButton>
    </template>
  </CModal>
</template>

<script>
export default {
  name: "skillInfoMessageModal",
  data() {
    return {
      modal: false,
    };
  },
  watch: {
    visible: {
      handler: function () {
        this.modal = this.visible;
      },
    },
  },
  props: {
    visible: {
      type: Boolean, // Boolean型に限定
      required: true, // 必須項目
    },
    message: {
      type: String,
      required: true,
    },
  },
  methods: {
    closeModal() {
      // クローズ処理
      this.modal = false;
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
/* 共通用CSS */
.labelsFont,
label:not(.notFontStyle):not(.label-delete):not(.border) {
  font-weight: bold;
}
</style>